const ReassuresFamiliesIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.0239 62.995C17.5989 62.995 17.2544 62.6505 17.2544 62.2255V29.3633C17.2544 28.9383 17.5989 28.5938 18.0239 28.5938C18.4489 28.5938 18.7934 28.9383 18.7934 29.3633V62.2255C18.7934 62.6505 18.4489 62.995 18.0239 62.995Z"
        fill="#FFA473"
      />
      <path
        d="M49.9555 63H8.6545C4.98518 63 2 60.0148 2 56.3455V35.2389C2 33.4539 2.69714 31.7779 3.96296 30.5195C5.22883 29.2611 6.90739 28.5702 8.69389 28.5844L17.5678 28.6369L29.0405 2.51171C29.3432 1.82248 29.9316 1.30777 30.6549 1.09939C31.3783 0.890837 32.1503 1.0139 32.7733 1.43649L35.5686 3.33301C37.6188 4.72402 38.8428 7.03359 38.8428 9.51113V22.4839H54.0418C56.3381 22.4839 58.5061 23.489 59.9898 25.2415C61.4736 26.994 62.1073 29.2981 61.7286 31.563L57.5461 56.5734C56.9233 60.2972 53.731 63 49.9555 63ZM8.65366 30.1233C7.29307 30.1233 6.0138 30.6509 5.04799 31.611C4.07493 32.5783 3.539 33.8668 3.539 35.2389V56.3455C3.539 59.1662 5.83381 61.461 8.6545 61.461H49.9555C52.976 61.461 55.5299 59.2987 56.0282 56.3195L60.2106 31.3091C60.5146 29.4915 60.006 27.6424 58.8153 26.236C57.6245 24.8296 55.8846 24.0229 54.0418 24.0229H38.0733C37.6483 24.0229 37.3038 23.6784 37.3038 23.2534V9.51113C37.3038 7.54432 36.3321 5.71083 34.7045 4.60662L31.9093 2.71009C31.6658 2.54495 31.364 2.49685 31.0809 2.57828C30.7981 2.6597 30.5679 2.86101 30.4496 3.13056L18.7736 29.7189C18.6507 29.9985 18.3742 30.1789 18.0691 30.1789H18.0645L8.68478 30.1234C8.67448 30.1233 8.66396 30.1233 8.65366 30.1233Z"
        fill="#06AEB3"
      />
    </svg>
  );
};

export default ReassuresFamiliesIcon;
